'use client';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

import idsTokensDefault from '../../utils/tokens/idsTokens';

const styles = ({ idsTokens = idsTokensDefault }) => ({
  icon: {
    marginLeft: -1,
  },
  small: {
    fontSize: `${idsTokens.icon.IDS.sizing.xs.height} !important`,
  },
  medium: {
    fontSize: `${idsTokens.icon.IDS.sizing.sm.height} !important`,
  },
});

const useStyles = makeStyles()(styles);

export const IconComponent = ({ icon, size }) => {
  const { classes, cx } = useStyles();
  const ReactIcon = icon;
  const iconComponent = React.isValidElement(icon) ? icon : <ReactIcon />;
  return React.cloneElement(iconComponent, { className: cx(classes.icon, classes[size]) });
};

export default IconComponent;
